import { useEffect } from "react";
import "./index.scss";
import { useState } from "react";
import ToggleCopy from "lib/ToggleCopy";
import ErrorMessage from "lib/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { setMinLength } from "redux/recursiveReducer";
import Label from "lib/Label";
import { clearSelectedDataKey } from "redux/formDisplay";
import { calculateGrandTotal } from "helper/calculateNetAsset";
import {
  assignValueToKey,
} from "redux/formDisplay";
const Toggle = (props) => {
  const {
    tooltip,
    id,
    label,
    name,
    onChange,
    value,
    is_disabled,
    is_checked,
    autofill,
    togglegroup,
    selectedData,
    error,
    events,
    size,
    validators,
    setSelectedData,
    formErr,
    setFormErr,
    clearFieldError,
    isEditable, // is used when RM requests to resend certain fields to the applicant
    // when editable is true only that field will be editable and rest will be disabled
  } = props;
  const [isToggled, setIsToggled] = useState(value || false);
  const dispatch = useDispatch();
  const toggleFields = useSelector((state) => state.formData?.toggleFields)
  const IndirectEval = (evalString) => {
    return eval(evalString);
  };
  useEffect(() => {
    if (is_checked) {
      setIsToggled(true);
    }
  }, []);
  // console.log("err",error);
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const onToggle = () => {
    let toggle = isToggled;
    setIsToggled(!isToggled);
    if(events){
      IndirectEval(events?.onToggle)
    }
    onChange(name, !toggle);
  };
  //TODO : need to add the isEditable code
  useEffect(() => {
    if(selectedData[`${name}`] === false){
      toggleFields[`${name}`]?.map((item) => {
        dispatch(clearSelectedDataKey({key: item}))
      })
    }
  },[isToggled])

  const calculateTheTotal = async (add, subtract, netField, totalField) => {
    calculateGrandTotal(add, subtract, netField, totalField, selectedData, dispatch, assignValueToKey)
    }  ;
  return (
    <>
      {autofill?.length ? (
        <ToggleCopy
          name={name}
          label={label}
          togglesublabel={label}
          autofill={autofill}
          togglegroup={togglegroup}
          setSelectedData={setSelectedData}
          selectedData={selectedData}
          isEditable={isEditable}
          formErr={formErr}
          setFormErr={setFormErr}
          clearFieldError={clearFieldError}
          is_disabled={IndirectEval(is_disabled)}
          size={size}
        />
      ) : (
        <div className={`toggle ${errorClass} .bg-theme-grey-2 `}>
          <div className="toggle_switch d-flex">
            <Label className="toggle_label fw-600" isToggle={true} htmlFor={name} label={label} tooltip={tooltip} validators={validators} />

            <label className="toggle_switch_label" htmlFor={name}>
              <input
                className={`toggle_switch_input `}
                disabled={is_disabled ? IndirectEval(is_disabled) : isEditable ? false : true}
                checked={is_checked ? is_checked : value}
                name={name}
                type="checkbox"
                id={name}
                onChange={onToggle}
              />
              <div className="switch"></div>
            </label>
          </div>
        </div>
      )}
      {error?.length !== 0 && <ErrorMessage error={error} />}
    </>
  );
};

export default Toggle;
